import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';

const Description = () => {
  const { content } = useJobContext();

  return (
    <>
      <Box mt={6} font="h3-semibold">
        {s__('JobsV2|Description')}
      </Box>
      <Divider mt={3} mb={4} />
      <Box
        className="ckeditor-content--reset"
        display="inline"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </>
  );
};

export default Description;
